module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"audit_import_title":"Audit-Fragenlisten Import","import_standard":"Importieren","description_label":"Beschreibung","audits_label":"Audit Metadaten","audits_placeholder":"JSON [\\n { \\"name\\" : \\"Audit Name\\", \\"standard\\" : \\"ISO9001\\",\\n ...\\n]\\noder CSV:\\n\\"Audit Name\\";\\"ISO9001\\"","field_required":"Feld darf nicht leer sein"},"en":{}}')
  delete Component.options._Ctor
}
